module.exports = __webpack_public_path__ + "static/media/doctor-detail.b92bd41e.jpg";